import React, { useState, useEffect } from 'react'
import { Query, Mutation } from 'react-apollo'
import {
  message, Menu, Dropdown, Icon, Select, Button as AntdButton, Modal, Spin, Input,
} from 'antd'
import _ from 'lodash'
import {
  SmallText, Div,
} from 'konsys-ui'
import { theme } from '../../styles/_variables'
import { Text } from './styled'
import PERMISSION from '../../constants/permissions'
import { checkNotNumber } from '../../utils/util-services'
import {
  GET_TRUCK_BRAND_LIST, GET_SENDERS, GET_RECEIVERS, GET_RECOMMEND_FUEL_LIST,
} from '../../constants/graphql/query'
import {
  CREATE_RECOMMEND_FUEL, UPDATE_RECOMMEND_FUEL, DELETE_RECOMMEND_FUEL,
} from '../../constants/graphql/mutation'

const { color } = theme

export const CellText = props => (
  <Text font='sarabun' {...props}>{props.children}</Text>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)}/>
)

export const TruckBrandFilter = ({ onChange, value }) => (
  <Query query={GET_TRUCK_BRAND_LIST}>
    {({ data, loading, error }) => {
      if (error) {
        console.error('TruckBrandFilter error:', error)
        return <Select placeholder='เกิดข้อผิดพลาด' disabled />
      }
      if (loading && _.isEmpty(data)) {
        return <Select placeholder='กำลังโหลด...' loading />
      }
      const list = data?.TruckBrandList?.lists || []
      return (
        <div className="recommend-fuel-select-filter">
          <Select
            showSearch
            allowClear
            placeholder='ค้นหา'
            value={value}
            loading={loading}
            onChange={e => onChange(e || undefined)}
            filterOption={(input, option) => {
              const { children } = option.props
              return children && children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }}
            style={{
              width: '100%',
            }}
            notFoundContent={loading ? <Spin size="small" /> : null}
          >
            {list.map(v => (
              <Select.Option key={v.id} value={v.id}>
                {v.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      )
    }}
  </Query>
)

export const SenderLocationFilter = ({ onChange, value }) => {
  const [searchName, setSearchName] = useState('')
  return (
    <Query
      query={GET_SENDERS}
      variables={{
        name: searchName,
        limit: 10,
      }}
    >
      {({
        data, loading, error, refetch,
        }) => {
        if (error) {
          console.error('SenderLocationFilter error:', error)
          return <Select placeholder='เกิดข้อผิดพลาด' disabled />
        }
        if (loading && _.isEmpty(data)) {
          return <Select placeholder='กำลังโหลด...' loading />
        }
        const list = data?.SenderLocationList?.lists || []
        return (
          <div className="recommend-fuel-select-filter">
            <Select
              showSearch
              allowClear
              placeholder='ค้นหา'
              value={value}
              loading={loading}
              onSearch={(e) => {
                setSearchName(e)
                refetch({ name: e, limit: 10 })
              }}
              onChange={e => onChange(e || undefined)}
              filterOption={false}
              style={{
                width: '100%',
              }}
              notFoundContent={loading ? <Spin size="small" /> : null}
            >
              {list.map(v => (
                <Select.Option key={v.id} value={v.id}>
                  {v.name} {v.branch}
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      }}
    </Query>
  )
}

export const ReceiverLocationFilter = ({ onChange, value }) => {
  const [searchName, setSearchName] = useState('')
  return (
    <Query
      query={GET_RECEIVERS}
      variables={{
        name: searchName,
        limit: 10,
      }}
    >
      {({
        data, loading, error, refetch,
        }) => {
        if (error) {
          console.error('ReceiverLocationFilter error:', error)
          return <Select placeholder='เกิดข้อผิดพลาด' disabled />
        }
        if (loading && _.isEmpty(data)) {
          return <Select placeholder='กำลังโหลด...' loading />
        }
        const list = data?.ReceiverLocationList?.lists || []
        return (
          <div className="recommend-fuel-select-filter">
            <Select
              showSearch
              allowClear
              placeholder='ค้นหา'
              value={value}
              loading={loading}
              onSearch={(e) => {
                setSearchName(e)
                refetch({ name: e, limit: 10 })
              }}
              onChange={e => onChange(e || undefined)}
              filterOption={false}
              style={{
                width: '100%',
              }}
              notFoundContent={loading ? <Spin size="small" /> : null}
            >
              {list.map(v => (
                <Select.Option key={v.id} value={v.id}>
                  {v.name} {v.branch}
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      }}
    </Query>
  )
}

const menu = (rowData, onEditClick, onDeleteClick) => (
  <Div>
    <Menu>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.CREATE_FUEL_ORDER_OVER_LIMIT)}>
        <span onClick={() => onEditClick(rowData)}>แก้ไข</span>
      </Menu.Item>
      <Menu.Item key='delete' disabled={!_.includes(window.perms, PERMISSION.CREATE_FUEL_ORDER_OVER_LIMIT)}>
        <span onClick={() => onDeleteClick(rowData)}>ลบ</span>
      </Menu.Item>
    </Menu>
  </Div>
)

export const ActionSelector = ({ props: { original }, onEditClick, onDeleteClick }) => (
  <Dropdown overlay={menu(original, onEditClick, onDeleteClick)} trigger='click'>
    <AntdButton>
      แก้ไข <Icon type="down" />
    </AntdButton>
  </Dropdown>
)

export const RecommendFuelModal = ({
 visible, onCancel, onSuccess, editData, refetch,
}) => {
  const [truckBrandId, setTruckBrandId] = useState(editData?.truckBrandId)
  const [senderLocationId, setSenderLocationId] = useState(editData?.senderLocationId)
  const [receiverLocationId, setReceiverLocationId] = useState(editData?.receiverLocationId)
  const [amount, setAmount] = useState(editData?.amount)
  const [senderSearchName, setSenderSearchName] = useState('')
  const [receiverSearchName, setReceiverSearchName] = useState('')

  const isEditMode = !!editData

  useEffect(() => {
    if (editData) {
      setTruckBrandId(editData.truckBrandId)
      setSenderLocationId(editData.senderLocationId)
      setReceiverLocationId(editData.receiverLocationId)
      setAmount(editData.amount)
    } else {
      setTruckBrandId(undefined)
      setSenderLocationId(undefined)
      setReceiverLocationId(undefined)
      setAmount(undefined)
    }
    setSenderSearchName('')
    setReceiverSearchName('')
  }, [editData, visible])

  const resetForm = () => {
    setTruckBrandId(undefined)
    setSenderLocationId(undefined)
    setReceiverLocationId(undefined)
    setAmount(undefined)
    setSenderSearchName('')
    setReceiverSearchName('')
  }

  const handleCancel = () => {
    resetForm()
    onCancel()
  }

  const mutation = isEditMode ? UPDATE_RECOMMEND_FUEL : CREATE_RECOMMEND_FUEL

  return (
    <Mutation
      mutation={mutation}
      refetchQueries={[{ query: GET_RECOMMEND_FUEL_LIST }]}
    >
      {(doAction, { loading: mutationLoading }) => (
        <Modal
          title={isEditMode ? 'แก้ไขรายการน้ำมันที่แนะนำ' : 'เพิ่มรายการน้ำมันที่แนะนำ'}
          visible={visible}
          destroyOnClose
          onCancel={handleCancel}
          onOk={() => {
            if (isEditMode) {
              if (!amount) {
                message.error('กรุณากรอกจำนวนน้ำมัน')
                return
              }
              doAction({
                variables: {
                  updateRecommendFuelId: editData.id,
                  amount: parseFloat(amount),
                },
              }).then(({ data }) => {
                const resp = data.UpdateRecommendFuel
                if (resp.success) {
                  message.success(resp.message)
                  if (onSuccess) onSuccess()
                  if (refetch) refetch()
                  resetForm()
                } else {
                  message.error(resp.message)
                }
              }).catch((error) => {
                message.error('เกิดข้อผิดพลาด')
                console.error(error)
              })
            } else {
              if (!truckBrandId || !senderLocationId || !receiverLocationId || !amount) {
                message.error('กรุณากรอกข้อมูลให้ครบถ้วน')
                return
              }
              doAction({
                variables: {
                  senderLocationId,
                  receiverLocationId,
                  truckBrandId,
                  amount: parseFloat(amount),
                },
              }).then(({ data }) => {
                const resp = data.CreateRecommendFuel
                if (resp.success) {
                  message.success(resp.message)
                  if (onSuccess) onSuccess()
                  if (refetch) refetch()
                  resetForm()
                } else {
                  message.error(resp.message)
                }
              }).catch((error) => {
                message.error('เกิดข้อผิดพลาด')
                console.error(error)
              })
            }
          }}
          okText={isEditMode ? 'บันทึก' : 'เพิ่มรายการใหม่'}
          cancelText='ยกเลิก'
          width={600}
          okButtonProps={{
            loading: mutationLoading,
          }}
          cancelButtonProps={{
            disabled: mutationLoading,
          }}
        >
          <Div display='flex' flexDirection='column'>
            <Div display='flex' alignItems='center' margin='0 0 16px' gap='12px'>
              <SmallText bold style={{ width: '140px', whiteSpace: 'nowrap' }}>ยี่ห้อรถ *</SmallText>
              <Query query={GET_TRUCK_BRAND_LIST}>
                {({ data, loading, error }) => {
                  if (error) {
                    return <Select placeholder='เกิดข้อผิดพลาด' disabled style={{ width: '100%' }} />
                  }
                  const list = data?.TruckBrandList?.lists || []
                  const listWithDefault = (!isEditMode || !truckBrandId || list.some(v => v.id === truckBrandId))
                    ? list
                    : [{ id: truckBrandId, name: editData?.truckBrand?.name || truckBrandId }, ...list]
                  return (
                    <Select
                      showSearch
                      placeholder='เลือกยี่ห้อรถ'
                      value={truckBrandId}
                      loading={loading}
                      onChange={setTruckBrandId}
                      disabled={isEditMode}
                      filterOption={(input, option) => {
                        const { children } = option.props
                        return children && children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }}
                      style={{ width: '100%' }}
                      notFoundContent={loading ? <Spin size="small" /> : null}
                    >
                      {listWithDefault.map(v => (
                        <Select.Option key={v.id} value={v.id}>
                          {v.name}
                        </Select.Option>
                      ))}
                    </Select>
                  )
                }}
              </Query>
            </Div>

            <Div display='flex' alignItems='center' margin='0 0 16px' gap='12px'>
              <SmallText bold style={{ width: '140px', whiteSpace: 'nowrap' }}>ต้นทาง *</SmallText>
              <Query
                query={GET_SENDERS}
                variables={{
                  name: senderSearchName,
                  limit: 10,
                }}
              >
                {({
                  data, loading, error, refetch: refetchSender,
                }) => {
                  if (error) {
                    return <Select placeholder='เกิดข้อผิดพลาด' disabled style={{ width: '100%' }} />
                  }
                  const list = data?.SenderLocationList?.lists || []
                  const listWithDefault = (!isEditMode || !senderLocationId || list.some(v => v.id === senderLocationId))
                    ? list
                    : [{ id: senderLocationId, name: editData?.senderLocation?.name || senderLocationId }]
                  return (
                    <Select
                      showSearch
                      placeholder='เลือกต้นทาง'
                      value={senderLocationId}
                      loading={loading}
                      disabled={isEditMode}
                      onSearch={(e) => {
                        setSenderSearchName(e)
                        refetchSender({ name: e, limit: 10 })
                      }}
                      onChange={setSenderLocationId}
                      filterOption={false}
                    style={{ width: '100%' }}
                      notFoundContent={loading ? <Spin size="small" /> : null}
                    >
                      {listWithDefault.map(v => (
                        <Select.Option key={v.id} value={v.id}>
                          {v.name} {v.branch}
                        </Select.Option>
                      ))}
                    </Select>
                  )
                }}
              </Query>
            </Div>

            <Div display='flex' alignItems='center' margin='0 0 16px' gap='12px'>
              <SmallText bold style={{ width: '140px', whiteSpace: 'nowrap' }}>ปลายทาง *</SmallText>
              <Query
                query={GET_RECEIVERS}
                variables={{
                  name: receiverSearchName,
                  limit: 10,
                }}
              >
                {({
                  data, loading, error, refetch: refetchReceiver,
                }) => {
                  if (error) {
                    return <Select placeholder='เกิดข้อผิดพลาด' disabled style={{ width: '100%' }} />
                  }
                  const list = data?.ReceiverLocationList?.lists || []
                  const listWithDefault = (!isEditMode || !receiverLocationId || list.some(v => v.id === receiverLocationId))
                    ? list
                    : [{ id: receiverLocationId, name: editData?.receiverLocation?.name || receiverLocationId }]
                  return (
                    <Select
                      showSearch
                      placeholder='เลือกปลายทาง'
                      value={receiverLocationId}
                      loading={loading}
                      disabled={isEditMode}
                      onSearch={(e) => {
                        setReceiverSearchName(e)
                        refetchReceiver({ name: e, limit: 10 })
                      }}
                      onChange={setReceiverLocationId}
                      filterOption={false}
                    style={{ width: '100%' }}
                      notFoundContent={loading ? <Spin size="small" /> : null}
                    >
                      {listWithDefault.map(v => (
                        <Select.Option key={v.id} value={v.id}>
                          {v.name} {v.branch}
                        </Select.Option>
                      ))}
                    </Select>
                  )
                }}
              </Query>
            </Div>

            <Div display='flex' alignItems='center' margin='0 0 16px' gap='12px'>
              <SmallText bold style={{ width: '140px', whiteSpace: 'nowrap' }}>น้ำมันที่แนะนำ *</SmallText>
              <Input
                type='number'
                step='0.1'
                min={0}
                value={amount}
                onKeyDown={e => checkNotNumber(e) && e.preventDefault()}
                onChange={e => setAmount(parseFloat(e.target.value) || '')}
                placeholder='กรอกจำนวนน้ำมัน (ลิตร)'
                style={{ width: '100%' }}
              />
            </Div>
          </Div>
        </Modal>
      )}
    </Mutation>
  )
}

export const DeleteConfirmModal = ({
  visible, onCancel, onConfirm, deleteData, refetch,
  }) => (
    <Mutation
      mutation={DELETE_RECOMMEND_FUEL}
      refetchQueries={[{ query: GET_RECOMMEND_FUEL_LIST }]}
    >
      {(doAction, { loading: deleteLoading }) => (
        <Modal
          title='ยืนยันการลบ'
          visible={visible}
          onCancel={onCancel}
          onOk={() => {
            if (!deleteData?.id) {
              message.error('ไม่พบข้อมูลที่ต้องการลบ')
              return
            }
            doAction({
              variables: {
                deleteRecommendFuelId: deleteData.id,
              },
            }).then(({ data }) => {
              const resp = data.DeleteRecommendFuel
              if (resp.success) {
                message.success(resp.message)
                if (onConfirm) onConfirm()
                if (refetch) refetch()
              } else {
                message.error(resp.message)
              }
            }).catch((error) => {
              message.error('เกิดข้อผิดพลาด')
              console.error(error)
            })
          }}
          okText='ลบ'
          cancelText='ยกเลิก'
          okButtonProps={{
            loading: deleteLoading,
            danger: true,
          }}
          cancelButtonProps={{
            disabled: deleteLoading,
          }}
        >
          <Div>
            <SmallText>คุณต้องการลบรายการนี้หรือไม่?</SmallText>
          </Div>
        </Modal>
      )}
    </Mutation>
)

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)
